// The CPQ2 home page: choose which configurator to open.
//
// Shown on a "Configure" launch, where the product is not yet decided. NOT shown
// on "Edit Config" — there the item already determines its configurator (the product
// stamp in its saved snapshot), so asking would be asking a question we know the
// answer to. See App.tsx.
//
// Only ENABLED products are offered. A disabled entry stays in products.json so a
// half-imported configurator cannot be launched by accident, while items already
// built with it remain editable through Edit Config.

import type { PageEntry, ProductEntry } from "../data/loader";

export default function ProductPicker({
  products,
  pages = [],
  onPick,
}: {
  products: ProductEntry[];
  /** Tools that are their own page (the Laser Job). A plain link in this same window, carrying
   *  this launch's URL parameters, so they keep the order (window.opener) and its context. */
  pages?: PageEntry[];
  onPick: (slug: string) => void;
}) {
  const available = products.filter((p) => p.enabled);

  return (
    <div className="cpq-home">
      <header className="cpq-home-head">
        <div className="cpq-brand">Flameco</div>
        <h1>CPQ2</h1>
        <p>Choose a configurator.</p>
      </header>

      {available.length === 0 && pages.length === 0 ? (
        // Every product disabled is a configuration problem, not an empty state —
        // say so, because a bare "nothing here" reads as a broken page.
        <div className="cpq-home-empty">
          <p>
            No configurator is currently enabled. Check <code>products.json</code> —
            entries exist but all are marked disabled.
          </p>
        </div>
      ) : (
        <ul className="cpq-home-list">
          {available.map((p) => (
            <li key={p.slug}>
              <button type="button" className="cpq-home-card" onClick={() => onPick(p.slug)}>
                <span className="cpq-home-card-name">{p.name}</span>
              </button>
            </li>
          ))}
          {pages.map((p) => (
            <li key={p.slug}>
              <a className="cpq-home-card" href={p.href + window.location.search}>
                <span className="cpq-home-card-name">{p.name}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
